import { createSelector } from "reselect";
import { exportsSelector } from "../../exports_selector";

/**
 * Selector for the populationTally section of the export state tree
 */
export const populationTallyExportSelector = createSelector(
  exportsSelector,
  exports => exports.populationTallyExport
);
